import { useTranslation } from 'react-i18next'

import { useUser } from 'app/user/application'

import { PageHeader } from '../components'
import styles from './ApiKeys.module.scss'
import CredentialField from './CredentialField'

const ApiKeys = () => {
  const { t } = useTranslation('settings')
  const { workspace } = useUser()

  return (
    <>
      <PageHeader title={t('pages.api-keys.title')} description={t('pages.api-keys.description')} />
      <section className={styles.credentials}>
        <CredentialField
          copyLabel={t('access.copy', { value: t('access.workspaceId.title') })}
          description={t('access.workspaceId.description')}
          label={t('access.workspaceId.title')}
          value={workspace.id}
        />
        <CredentialField
          copyLabel={t('access.copy', { value: t('access.apiSecret.title') })}
          description={t('access.apiSecret.description')}
          label={t('access.apiSecret.title')}
          value={workspace.apiKey}
        />
      </section>
    </>
  )
}

export default ApiKeys
